// extracted by mini-css-extract-plugin
module.exports = {"anchor":"style_anchor__1Vf_d","title":"style_title__3qX6t","inlineBlock":"style_inlineBlock__18LWv","redBackgroundColor":"style_redBackgroundColor__1APfA"};